import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {NavigationBarComponent} from './navigation-bar.component';
import {ProductDetailsNavigationLinkService} from './product-details-navigation-link.service';
import {MediaModule} from '@spartacus/storefront';
import {ProductNameDisplayModule} from './product-name-display/product-name-display.module';
import {CtaFormModule} from '../../cta-form/cta-form.module';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [
    NavigationBarComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductCustomNavigationBarComponent: {
          component: NavigationBarComponent
        }
      }
    }),
    I18nModule,
    MediaModule,
    ProductNameDisplayModule,
    CtaFormModule,
    RouterModule
  ],
  providers: [
    ProductDetailsNavigationLinkService
  ],
  exports: [
    NavigationBarComponent,
  ]
})
export class NavigationBarModule {
}
